export default __webpack_public_path__ + "static/media/23.e9ca8278.png";